export default "__VITE_ASSET__D7E16hqL__"